<template>
  <b-modal v-model="isVisible" centered hide-footer title="Report" size="lg" @hide="resetForm">
    <form @submit.prevent>
      <div class="form-group">
        <div class="row">
          <div class="col-6 mt-3">
            <label>IDP Period</label>
            <v-select
              v-model="idpPeriod"
              :options="filteredIdpPeriod"
              :reduce="(e) => e"
              label="label"
              placeholder="Select IDP Period"
              @input="handleSelectIdpPeriod"
            />
          </div>

          <div class="col-4 mt-3">
            <label>Period</label>
            <v-select
              v-model="period"
              :options="listPeriod"
              :reduce="(e) => e"
              label="label"
              placeholder="Select Period"
              @input="handleSelectPeriod"
              :disabled="!idpPeriod || isCustomDate"
            />
          </div>

          <div class="col-2 mt-3" v-if="showSubPeriod">
            <label>{{ subPeriodLabel }}</label>
            <v-select
              v-model="subPeriod"
              :options="subPeriodOptions"
              :reduce="(e) => e"
              label="label"
              placeholder="Select"
              class="sub-period-select"
            />
          </div>

          <div class="col-6 mt-3">
            <label>Start Date</label>
            <v-date-picker
              style="width: 100%"
              v-model="bodyAdd.startDate"
              type="date"
              format="DD-MM-YYYY"
              placeholder="Select Date"
              name="Start Date"
              :disabled="!idpPeriod || !!period"
              :disabled-date="disableStartDate"
              @input="checkCustomDate"
            />
          </div>

          <div class="col-6 mt-3">
            <label>End Date</label>
            <v-date-picker
              style="width: 100%"
              v-model="bodyAdd.endDate"
              type="date"
              format="DD-MM-YYYY"
              placeholder="Select Date"
              name="End Date"
              :disabled="!idpPeriod || !!period"
              :disabled-date="disableEndDate"
              @input="checkCustomDate"
            />
          </div>
        </div>
      </div>

      <div class="d-flex justify-content-end mt-5 gap-3 flex-wrap">
        <b-button
          class="btn btn-primary"
          variant="primary"
          @click="emitExport('tna')"
          :disabled="isExportDisabled"
        >
          <span class="fe fe-download"></span> TNA Report
        </b-button>
        <b-button
          class="btn btn-primary"
          variant="primary"
          @click="emitExport('training')"
          :disabled="isExportDisabled"
        >
          <span class="fe fe-download"></span> Training Report
        </b-button>
        <b-button
          class="btn btn-primary"
          variant="primary"
          @click="emitExport('idp')"
          :disabled="isExportDisabled"
        >
          <span class="fe fe-download"></span> IDP Report
        </b-button>
        <b-button
          class="btn btn-primary"
          variant="primary"
          @click="emitExport('tna', 'enrolled')"
          :disabled="isExportDisabled"
        >
          <span class="fe fe-download"></span> Enrollment Report
        </b-button>
      </div>
    </form>
  </b-modal>
</template>

<script>
import moment from "moment";

export default {
  name: "ReportModal",
  props: {
    value: { type: Boolean, default: false },
    visible: { type: Boolean, default: undefined },
    listIdpPeriod: { type: Array, default: () => [] },
    role: { type: String, default: "employee" },
  },
  data() {
    return {
      isVisible: this.visible !== undefined ? this.visible : this.value,
      idpPeriod: null,
      period: null,
      subPeriod: null,
      bodyAdd: {
        startDate: null,
        endDate: null,
      },
      listPeriod: [
        { label: "Monthly", value: "monthly" },
        { label: "Quarterly", value: "quarterly" },
        { label: "Semester", value: "semester" },
        { label: "Annual", value: "annual" },
        { label: "All", value: "all" },
      ],
      isCustomDate: false,
    };
  },
  watch: {
    value(val) {
      if (this.visible === undefined) {
        this.isVisible = val;
      }
    },
    visible(val) {
      if (val !== undefined) {
        this.isVisible = val;
      }
    },
    isVisible(val) {
      this.$emit("input", val);
      this.$emit("update:visible", val);
    },
  },
  computed: {
    filteredIdpPeriod() {
      return this.listIdpPeriod.filter((p) => p.status !== "ready");
    },
    showSubPeriod() {
      return this.period?.value === "quarterly" || this.period?.value === "semester";
    },
    subPeriodLabel() {
      return this.period?.value === "quarterly" ? "Quarter" : "Semester";
    },
    subPeriodOptions() {
      if (this.period?.value === "quarterly") {
        return [
          { label: "I", value: "1" },
          { label: "II", value: "2" },
          { label: "III", value: "3" },
          { label: "IV", value: "4" },
        ];
      }
      if (this.period?.value === "semester") {
        return [
          { label: "I", value: "1" },
          { label: "II", value: "2" },
        ];
      }
      return [];
    },

    isExportDisabled() {
      if (!this.idpPeriod) return true;

      if (this.isCustomDate) return false;

      if (!this.period) return true;

      if ((this.period.value === "quarterly" || this.period.value === "semester") && !this.subPeriod) return true;

      return false;
    },
  },
  methods: {
    handleSelectIdpPeriod(period) {
      if (period && period.start_date && period.end_date) {
        this.bodyAdd.startDate = period.start_date;
        this.bodyAdd.endDate = period.end_date;
      } else {
        this.resetForm();
      }
    },
    handleSelectPeriod(val) {
      this.subPeriod = null;
      if (val) {
        this.bodyAdd.startDate = null;
        this.bodyAdd.endDate = null;
        this.isCustomDate = false;
      }
    },
    checkCustomDate() {
      const hasStart = !!this.bodyAdd.startDate;
      const hasEnd = !!this.bodyAdd.endDate;

      if (hasStart && hasEnd) {
        this.period = null;
        this.subPeriod = null;
        this.isCustomDate = true;
      } else {
        this.isCustomDate = false;

        if (this.idpPeriod?.start_date && this.idpPeriod?.end_date) {
          this.bodyAdd.startDate = this.idpPeriod.start_date;
          this.bodyAdd.endDate = this.idpPeriod.end_date;
        }
      }
    },
    disableStartDate(date) {
      return this.isDateDisabled({
        date,
        idpPeriod: this.idpPeriod,
        boundaryDate: this.bodyAdd.endDate,
        type: "start",
      });
    },
    disableEndDate(date) {
      return this.isDateDisabled({
        date,
        idpPeriod: this.idpPeriod,
        boundaryDate: this.bodyAdd.startDate,
        type: "end",
      });
    },
    isDateDisabled({ date, idpPeriod, boundaryDate, type }) {
      if (!idpPeriod?.start_date || !idpPeriod?.end_date) return false;

      const start = moment(idpPeriod.start_date);
      const end = moment(idpPeriod.end_date);
      const current = moment(date);

      let invalid = current.isBefore(start, "day") || current.isAfter(end, "day");

      if (boundaryDate) {
        const chosen = moment(boundaryDate);

        if (type === "start") invalid ||= current.isAfter(chosen, "day");
        if (type === "end") invalid ||= current.isBefore(chosen, "day");
      }

      return invalid;
    },
    resolveDateRange() {
      if (this.isCustomDate && this.bodyAdd.startDate && this.bodyAdd.endDate) {
        return {
          start_date: moment(this.bodyAdd.startDate).format("YYYY-MM-DD"),
          end_date: moment(this.bodyAdd.endDate).format("YYYY-MM-DD"),
        };
      }

      if (!this.idpPeriod?.start_date || !this.idpPeriod?.end_date) {
        return { start_date: null, end_date: null };
      }

      const periodStart = moment(this.idpPeriod.start_date);
      const periodEnd = moment(this.idpPeriod.end_date);
      const year = periodStart.year();
      const periodValue = this.period?.value;

      if (!periodValue || periodValue === "all" || periodValue === "annual") {
        return {
          start_date: periodStart.format("YYYY-MM-DD"),
          end_date: periodEnd.format("YYYY-MM-DD"),
        };
      }

      if (periodValue === "semester") {
        if (this.subPeriod?.value === "1") {
          return { start_date: `${year}-01-01`, end_date: `${year}-06-30` };
        }
        if (this.subPeriod?.value === "2") {
          return { start_date: `${year}-07-01`, end_date: `${year}-12-31` };
        }
      }

      if (periodValue === "quarterly") {
        const quarters = {
          1: [`${year}-01-01`, `${year}-03-31`],
          2: [`${year}-04-01`, `${year}-06-30`],
          3: [`${year}-07-01`, `${year}-09-30`],
          4: [`${year}-10-01`, `${year}-12-31`],
        };
        const quarter = quarters[this.subPeriod?.value];
        if (quarter) {
          return { start_date: quarter[0], end_date: quarter[1] };
        }
      }

      if (periodValue === "monthly") {
        const now = moment();
        const monthStart = moment.max(periodStart.clone(), now.clone().startOf("month"));
        const monthEnd = moment.min(periodEnd.clone(), now.clone().endOf("month"));

        if (monthStart.isAfter(monthEnd)) {
          return {
            start_date: periodStart.format("YYYY-MM-DD"),
            end_date: periodEnd.format("YYYY-MM-DD"),
          };
        }

        return {
          start_date: monthStart.format("YYYY-MM-DD"),
          end_date: monthEnd.format("YYYY-MM-DD"),
        };
      }

      return {
        start_date: periodStart.format("YYYY-MM-DD"),
        end_date: periodEnd.format("YYYY-MM-DD"),
      };
    },
    emitExport(type, status) {
      const { start_date, end_date } = this.resolveDateRange();

      const payload = {
        type,
        start_date,
        end_date,
      };

      if (status) payload.status = status;

      this.$emit("export", payload);
    },
    resetForm() {
      this.idpPeriod = null;
      this.period = null;
      this.subPeriod = null;
      this.bodyAdd = { startDate: null, endDate: null };
      this.isCustomDate = false;
    },
  },
};
</script>

<style scoped>
::v-deep(.sub-period-select .vs__dropdown-menu) {
  min-width: 100% !important;
  width: 100% !important;
  box-sizing: border-box;
}

.gap-3 > * + * {
  margin-left: 0.75rem;
}

.flex-wrap {
  flex-wrap: wrap;
  row-gap: 0.75rem;
}
</style>
